<!-- Loading spinner when content is not ready -->
<div class="loading-container" *ngIf="!loaded">
  <nb-spinner status="primary" size="large"></nb-spinner>
</div>
<div class="overlay" [hidden]="!loaded">
  <!-- Main content when loaded -->
  <div class="request-revision-email-card">
    <div class="request-revision-email-card-header">
      <p>Request Revision</p>
    </div>
    <p class="to">
      <span class="const">To: </span>
      <span class="field" *ngIf="!isBulkMode">{{ registrant.fields?.email }}</span>
      <span class="field" *ngIf="isBulkMode">Sending to {{ count }} registrants</span>
    </p>

    <div class="subject border">
      <div class="subject-line">
        <span class="const">Subject: </span>
        <span class="field" contenteditable (input)="email.subject = $event.target.innerHTML">{{ email.subject }}</span>
      </div>
    </div>

    <div class="message-wrapper border">
      <div id="toolbar"></div>
      <div class="message d-flex flex-column">
        <div class="message-editor">
          <ngx-editor
            *ngIf="loaded"
            [message]="email.message"
            [placeholder]="'Click here to edit'"
            (valueChange)="update($event)"
            (blurred)="editorOnBlur($event)"
            [attr.key]="selectedTemplateIndex"
          >
          </ngx-editor>
          <div class="edit-registration-button">
            <span contenteditable class="text-center w-100" (blur)="updateRegistrationButtonContent($event)">{{ registrationButtonContent }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="actions">
      <button class="close" (click)="close()">Cancel</button>
      <button class="send" (click)="send()">Send</button>
    </div>
  </div>
</div>
